export default __webpack_public_path__ + "static/media/FS9A0113-2.ac36f37b.png";